// extracted by mini-css-extract-plugin
module.exports = {"noteCon":"ratingAddNotes_noteCon__2yc-M","textBox":"ratingAddNotes_textBox__rvLOT","btnSubmit":"ratingAddNotes_btnSubmit__1ikEn"};